var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1665 1.66663V10.8333M18.3332 8.16663V4.33329C18.3332 3.39987 18.3332 2.93316 18.1516 2.57664C17.9918 2.26304 17.7368 2.00807 17.4232 1.84828C17.0667 1.66663 16.6 1.66663 15.6665 1.66663H6.76489C5.54699 1.66663 4.93804 1.66663 4.4462 1.88949C4.01271 2.08591 3.6443 2.40198 3.38425 2.80056C3.08919 3.25279 2.99659 3.85466 2.8114 5.0584L2.37551 7.89173C2.13125 9.47939 2.00912 10.2732 2.24472 10.8909C2.4515 11.433 2.84042 11.8864 3.34482 12.1732C3.91949 12.5 4.72266 12.5 6.32899 12.5H6.99988C7.46659 12.5 7.69995 12.5 7.87821 12.5908C8.03501 12.6707 8.16249 12.7982 8.24239 12.955C8.33321 13.1332 8.33321 13.3666 8.33321 13.8333V16.2784C8.33321 17.4133 9.25321 18.3333 10.3881 18.3333C10.6588 18.3333 10.9041 18.1739 11.014 17.9265L13.8146 11.6251C13.942 11.3385 14.0057 11.1952 14.1064 11.0901C14.1954 10.9972 14.3047 10.9262 14.4257 10.8826C14.5626 10.8333 14.7194 10.8333 15.033 10.8333H15.6665C16.6 10.8333 17.0667 10.8333 17.4232 10.6516C17.7368 10.4918 17.9918 10.2369 18.1516 9.92328C18.3332 9.56676 18.3332 9.10005 18.3332 8.16663Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDown);
export default __webpack_public_path__ + "static/media/thumbs-down.effc58fa4b7eb434993993c6df70570e.svg";
export { ForwardRef as ReactComponent };